module.exports = __webpack_public_path__ + "img/icon20.4d50a7e5.png";